import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { DateFromTo } from '../../models/common';
import { getDateTimeForApi } from '../../utils/date';
import { visitationService } from '@api/services/services';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';
import { InvitationType } from '@api/models/enums/InvitationType';
import { VisitationDto } from '@api/models/visitations/VisitationDto';
import { WorkplaceDto } from '@api/models/workplace/WorkplaceDto';

export interface VisitationListFilter extends ListFilter {
  supplier?: ReferenceDto;
  establishment?: ReferenceDto;
  workplace?: WorkplaceDto;
  invitedBy?: ReferenceDto;
  entryTime?: DateFromTo;
  exitTime?: DateFromTo;
  hasExited?: boolean;
  inAreal?: boolean;
  invitationTypes?: InvitationType[];
}

export type VisitationListState = ListType<VisitationDto, VisitationListFilter>;

const initialState: VisitationListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    hasExited: true,
  },
};

export const visitationListSlice = listSlice({
  name: 'visitationList',
  initialState,
});

export const selectVisitationList = (state: RootState) => state.visitationList;
export const visitationListActions = visitationListSlice.actions;

export const getVisitationList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectVisitationList(storeState);

  const handleGetData = (size: number) => {
    return visitationService.query(
      {
        q: data.query.q,
        supplier: data.query.supplier?.id,
        establishment: data.query.establishment?.id,
        workplace: data.query.workplace ? [data.query.workplace.id!] : undefined,
        employee: data.query.invitedBy?.id,
        entryTimeStart: getDateTimeForApi(data.query.entryTime?.from),
        entryTimeEnd: getDateTimeForApi(data.query.entryTime?.to),
        exitTimeStart: getDateTimeForApi(data.query.exitTime?.from),
        exitTimeEnd: getDateTimeForApi(data.query.exitTime?.to),
        hasExited: data.query.hasExited,
        inAreal: data.query.inAreal,
        invitationTypes: data.query.invitationTypes,
        page: data.query.page,
        size: size,
        sort: getListSort(data) ?? ['exitTime,desc', 'entryTime,desc'],
      },
      { cancelToken: cancelToken as any },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: visitationListActions,
    getData: handleGetData,
  });
};
